module.exports = __webpack_public_path__ + "img/stock5.b7af4806.png";